module.exports = __webpack_public_path__ + "img/stadia.6391d5ae.svg";